import $ from "jquery";
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";

var DEFAULT_VIEW = "timeGridWeek";

export function initCalendar(el) {
  var eventsUrl = el.getAttribute("data-events-url");
  var detailUrl = el.getAttribute("data-detail-url") || "";
  var initialView = el.getAttribute("data-initial-view") || DEFAULT_VIEW;
  var initialDate = el.getAttribute("data-initial-date") || undefined;
  var lang = document.documentElement.lang || "en";
  var filtersContainer = document.getElementById("category-filters");
  var calendarSelect = document.getElementById("calendar-select");
  var allEvents = [];
  var cachedStart = null;
  var cachedEnd = null;
  // Which categories the user has toggled on
  var activeFilters = new Set();
  // Which calendars are currently selected
  var activeCalendars = new Set();
  // category ID -> calendar ID lookup
  var catToCalendar = {};
  // All category IDs (for default detection)
  var allCategoryIds = new Set();
  // All calendar IDs (for default detection)
  var allCalendarIds = new Set();
  var calendar;

  // Custom agenda container
  var agendaContainer = document.createElement("div");
  agendaContainer.className = "fc-custom-agenda hidden";
  el.parentNode.insertBefore(agendaContainer, el.nextSibling);

  var weekdayFormatter = new Intl.DateTimeFormat(lang, { weekday: "short" });

  function renderCustomAgenda(start, end, events) {
    var dayMap = {};
    var current = new Date(start);
    while (current < end) {
      var key = current.getFullYear() + "-" +
        String(current.getMonth() + 1).padStart(2, "0") + "-" +
        String(current.getDate()).padStart(2, "0");
      dayMap[key] = { date: new Date(current), events: [] };
      current.setDate(current.getDate() + 1);
    }

    events.forEach(function (e) {
      var eStart = new Date(e.start);
      var eEnd = e.end ? new Date(e.end) : new Date(eStart.getTime() + 86400000);
      var from = eStart < start ? new Date(start) : new Date(eStart);
      var to = eEnd > end ? end : eEnd;
      from.setHours(0, 0, 0, 0);
      while (from < to) {
        var key = from.getFullYear() + "-" +
          String(from.getMonth() + 1).padStart(2, "0") + "-" +
          String(from.getDate()).padStart(2, "0");
        if (dayMap[key]) {
          dayMap[key].events.push(e);
        }
        from.setDate(from.getDate() + 1);
      }
    });

    var html = "";
    Object.keys(dayMap).sort().forEach(function (key) {
      var day = dayMap[key];
      if (day.events.length === 0) return;
      var d = day.date;
      var isSun = d.getDay() === 0;
      var dayNum = d.getDate();
      var weekday = weekdayFormatter.format(d);

      html += '<div class="fc-agenda-day' + (isSun ? " fc-agenda-day-sun" : "") + '">';
      html += '<div class="fc-agenda-date">';
      html += '<span class="fc-agenda-date-num">' + dayNum + "</span>";
      html += '<span class="fc-agenda-date-weekday">' + weekday + "</span>";
      html += "</div>";
      html += '<div class="fc-agenda-events">';

      day.events.forEach(function (e) {
        var color = e.color || e.backgroundColor || "#6b7280";
        var eventId = e.id || "";
        var slug = (e.extendedProps && e.extendedProps.slug) || "";
        html += '<div class="fc-agenda-event" data-event-id="' + eventId + '" data-slug="' + slug + '">';
        html += '<span class="fc-agenda-dot" style="background:' + color + '"></span>';
        html += '<span class="fc-agenda-event-title">' + (e.title || "") + "</span>";
        html += "</div>";
      });

      html += "</div></div>";
    });

    agendaContainer.innerHTML = html;

    if (detailUrl) {
      agendaContainer.querySelectorAll(".fc-agenda-event").forEach(function (el) {
        el.addEventListener("click", function () {
          var id = el.getAttribute("data-event-id");
          var slug = el.getAttribute("data-slug") || "";
          if (id) {
            window.location.href = detailUrl
              .replace("0", id)
              .replace("SLUG_PLACEHOLDER", slug);
          }
        });
      });
    }
  }

  function refreshAgendaIfActive() {
    if (calendar && calendar.view.type === "listWeek") {
      var view = calendar.view;
      renderCustomAgenda(view.activeStart, view.activeEnd, filterEvents(allEvents));
    }
  }

  // Build lookup and initialize categories from checkbox state
  var wrappers = filtersContainer.querySelectorAll("[data-category]");
  wrappers.forEach(function (wrapper) {
    var catId = wrapper.getAttribute("data-category");
    var calId = wrapper.getAttribute("data-calendar-id");
    var checkbox = wrapper.querySelector("input[type='checkbox']");
    allCategoryIds.add(catId);
    if (checkbox && checkbox.checked) {
      activeFilters.add(catId);
    }
    if (calId) {
      catToCalendar[catId] = calId;
    }
  });

  // Initialize activeCalendars from selected options
  if (calendarSelect) {
    Array.from(calendarSelect.options).forEach(function (opt) {
      allCalendarIds.add(opt.value);
    });
    Array.from(calendarSelect.selectedOptions).forEach(function (opt) {
      activeCalendars.add(opt.value);
    });
  }

  function isCategoryVisible(catId) {
    var calId = catToCalendar[catId];
    return !calId || activeCalendars.has(calId);
  }

  function filterEvents(events) {
    return events.filter(function (e) {
      var catId = String(e.extendedProps.categoryId);
      return activeFilters.has(catId) && isCategoryVisible(catId);
    });
  }

  function updateCategoryPills() {
    var wrappers = filtersContainer.querySelectorAll(
      "[data-category]",
    );
    wrappers.forEach(function (wrapper) {
      var catId = wrapper.getAttribute("data-category");
      var visible = isCategoryVisible(catId);
      wrapper.style.display = visible ? "" : "none";
    });
  }

  function pushStateToUrl() {
    if (!calendar) return;
    var params = new URLSearchParams();

    // Categories: omit if all are active
    if (activeFilters.size !== allCategoryIds.size) {
      var catIds = Array.from(activeFilters).sort().join(",");
      if (catIds) params.set("categories", catIds);
    }

    // Calendars: omit if all are selected
    if (activeCalendars.size !== allCalendarIds.size) {
      var calIds = Array.from(activeCalendars).sort().join(",");
      if (calIds) params.set("calendars", calIds);
    }

    // View: omit if default
    var currentView = calendar.view.type;
    if (currentView !== DEFAULT_VIEW) {
      params.set("view", currentView);
    }

    // Date: omit if today (use local date to avoid UTC shift)
    var currentDate = calendar.getDate();
    var today = new Date();
    var currentDateStr =
      currentDate.getFullYear() + "-" +
      String(currentDate.getMonth() + 1).padStart(2, "0") + "-" +
      String(currentDate.getDate()).padStart(2, "0");
    var todayStr =
      today.getFullYear() + "-" +
      String(today.getMonth() + 1).padStart(2, "0") + "-" +
      String(today.getDate()).padStart(2, "0");
    if (currentDateStr !== todayStr) {
      params.set("date", currentDateStr);
    }

    var qs = params.toString();
    var newUrl = window.location.pathname + (qs ? "?" + qs : "");
    history.replaceState(null, "", newUrl);

    // Update iCal button URL to reflect current filter params
    var icalBtn = document.getElementById("ical-copy-btn");
    if (icalBtn) {
      var icalParams = new URLSearchParams();
      if (activeFilters.size !== allCategoryIds.size) {
        var icalCatIds = Array.from(activeFilters).sort().join(",");
        if (icalCatIds) icalParams.set("categories", icalCatIds);
      }
      if (activeCalendars.size !== allCalendarIds.size) {
        var icalCalIds = Array.from(activeCalendars).sort().join(",");
        if (icalCalIds) icalParams.set("calendars", icalCalIds);
      }
      var icalQs = icalParams.toString();
      var origin = window.location.origin;
      var basePath = icalBtn.getAttribute("data-ical-url").replace(/\?.*$/, "").replace(origin, "");
      icalBtn.setAttribute("data-ical-url", origin + basePath + (icalQs ? "?" + icalQs : ""));
    }
  }

  function applyFilters() {
    updateCategoryPills();
    if (calendar) calendar.refetchEvents();
    refreshAgendaIfActive();
    pushStateToUrl();
  }

  // Calendar select change handler (Select2 fires jQuery events)
  if (calendarSelect) {
    $(calendarSelect).on("change", function () {
      activeCalendars.clear();
      Array.from(calendarSelect.selectedOptions).forEach(
        function (opt) {
          activeCalendars.add(opt.value);
        },
      );
      applyFilters();
    });
  }

  // Category checkbox change handler
  filtersContainer.addEventListener("change", function (e) {
    var checkbox = e.target;
    if (checkbox.type !== "checkbox") return;
    var wrapper = checkbox.closest("[data-category]");
    if (!wrapper) return;
    var catId = wrapper.getAttribute("data-category");
    if (checkbox.checked) {
      activeFilters.add(catId);
    } else {
      activeFilters.delete(catId);
    }
    applyFilters();
  });

  // Copy iCal link to clipboard
  var icalCopyBtn = document.getElementById("ical-copy-btn");
  if (icalCopyBtn) {
    icalCopyBtn.addEventListener("click", function () {
      var url = icalCopyBtn.getAttribute("data-ical-url");
      var label = icalCopyBtn.querySelector(".ical-label");
      var original = label ? label.textContent : "";

      function showFeedback(text) {
        if (!label) return;
        label.textContent = text;
        setTimeout(function () {
          label.textContent = original;
        }, 2000);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(
          function () { showFeedback("\u2713 Copied!"); },
          function () { fallbackCopy(url); }
        );
      } else {
        fallbackCopy(url);
      }

      function fallbackCopy(text) {
        var textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand("copy");
          showFeedback("\u2713 Copied!");
        } catch (e) {
          showFeedback("Failed to copy");
        }
        document.body.removeChild(textarea);
      }
    });
  }

  // Conditionally load Slovenian locale
  var localePromise =
    lang === "sl"
      ? import(
          /* webpackInclude: /sl\.js$/ */
          "@fullcalendar/core/locales/sl"
        ).then(function (mod) {
          return mod.default;
        })
      : Promise.resolve(null);

  localePromise.then(function (localeData) {
    var calendarOpts = {
      plugins: [dayGridPlugin, timeGridPlugin, listPlugin],
      initialView: initialView,
      headerToolbar: {
        left: "prev,next today",
        center: "title",
        right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
      },
      nowIndicator: true,
      slotMinTime: "07:00:00",
      slotMaxTime: "24:00:00",
      allDaySlot: true,
      allDayText: "",
      height: "auto",
      expandRows: true,
      slotDuration: "00:30:00",
      slotLabelInterval: "01:00:00",
      dayMaxEvents: 3,
      dayCellContent: function (arg) {
        return arg.dayNumberText.replace(".", "");
      },
      slotLabelFormat: { hour: "2-digit", minute: "2-digit", hour12: false },
      views: {
        dayGridMonth: {
          dayHeaderFormat: { weekday: "long" },
        },
        timeGridWeek: {
          dayHeaderFormat: { weekday: "long", day: "numeric", month: "numeric" },
        },
        timeGridDay: {
          dayHeaderFormat: { weekday: "long", day: "numeric", month: "numeric" },
        },
      },
      navLinks: true,
      weekNumbers: false,
      firstDay: 1,

      events: function (info, successCallback, failureCallback) {
        if (
          cachedStart === info.startStr &&
          cachedEnd === info.endStr
        ) {
          successCallback(filterEvents(allEvents));
          return;
        }
        var params = new URLSearchParams({
          start: info.startStr,
          end: info.endStr,
        });
        fetch(eventsUrl + "?" + params.toString())
          .then(function (r) {
            if (!r.ok) throw new Error("HTTP " + r.status);
            return r.json();
          })
          .then(function (data) {
            allEvents = data;
            cachedStart = info.startStr;
            cachedEnd = info.endStr;
            successCallback(filterEvents(data));
            refreshAgendaIfActive();
          })
          .catch(failureCallback);
      },

      datesSet: function (info) {
        var isListView = info.view.type === "listWeek";
        agendaContainer.classList.toggle("hidden", !isListView);
        var harness = el.querySelector(".fc-view-harness");
        if (harness) harness.style.display = isListView ? "none" : "";
        if (isListView) {
          renderCustomAgenda(info.view.activeStart, info.view.activeEnd, filterEvents(allEvents));
        }
        pushStateToUrl();
      },

      eventClick: function (info) {
        var id = info.event.id;
        var slug = info.event.extendedProps.slug || "";
        if (id && detailUrl) {
          info.jsEvent.preventDefault();
          window.location.href = detailUrl
            .replace("0", id)
            .replace("SLUG_PLACEHOLDER", slug);
        }
      },

      eventDidMount: function (info) {
        info.el.style.cursor = "pointer";
      },
    };

    if (initialDate) {
      calendarOpts.initialDate = initialDate;
    }

    if (localeData) {
      calendarOpts.locale = localeData;
    }

    calendar = new Calendar(el, calendarOpts);
    calendar.render();
    updateCategoryPills();
  });
}
